<template>
  <div class="form-group c-historical-orders-date-range-filter">
    <v-form-group :label="label" class="form-group-root p-0">
      <v-form-select
        v-model="selectedDateModel"
        :value="selectedDateRangeId"
        :options="options"
        @input="onDateRangeChanged"
        :aria-label="label"
      />
    </v-form-group>
    <v-form-group :label="i18n('accountHeader.fromDate')" v-if="customRangeSelected" class="date-class pr-0">
      <v-form-datepicker
        detached
        boundary="window"
        value-as-date
        :value="fromDate"
        :locale="$i18n.locale"
        :initial-date="minDate()"
        :labelHelp="$t('white-label.components.datepicker.labelHelp')"
        :labelPrevMonth="$t('white-label.components.datepicker.labelPrevMonth')"
        :labelCurrentMonth="$t('white-label.components.datepicker.labelCurrentMonth')"
        :labelNextMonth="$t('white-label.components.datepicker.labelNextMonth')"
        :labelNoDateSelected="$t('white-label.components.datepicker.labelNoDateSelected')"
        :min="minDate()"
        :max="maxDate()"
        @input="onFromDateChanged"
        v-if="customRangeSelected"
      />
    </v-form-group>
    <v-form-group :label="i18n('accountHeader.toDate')" v-if="customRangeSelected" class="date-class pr-0">
      <v-form-datepicker
        detached
        boundary="window"
        value-as-date
        :value="toDate"
        :locale="$i18n.locale"
        :labelNoDateSelected="$t('white-label.components.datepicker.labelNoDateSelected')"
        :min="minDate(false)"
        :max="maxDate(false)"
        @input="onToDateChanged"
        v-if="customRangeSelected"
      />
    </v-form-group>
    <v-button
      class="box-shadow-buttons  historical-date-apply"
      @click="applyDateRange"
      :disabled="customRangeSelected && (!fromDate || !toDate)"
      v-if="showApplyButton"
      >{{ i18n('accountHeader.apply') }}</v-button
    >
  </div>
</template>

<script>
import moment from 'moment';
import { toTimezoneDate } from '@/utils/date';

export default {
  name: 'c-historical-orders-date-range-filter',
  props: {
    label: {
      type: String,
      required: true
    },
    powerUser: {
      type: Boolean,
      required: true,
      default: false
    },
    fromDate: {
      type: Date,
      default: null
    },
    toDate: {
      type: Date,
      default: null
    },
    maxDateRange: {
      type: Number,
      default: 60
    },
    selectedDateRangeId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selected: null,
      selectedDateModel: null,
      customRangeSelected: false,
      controlDateFrom: moment().subtract(1, 'month'),
      controlDateTo: moment(),
      dateFormat: 'MM-DD-YYYY',
      dateFormatShow: {
        day: true,
        month: true,
        year: false
      },
      parentCompStr: 'historical',
      hoEndDate: moment()
        .subtract(1, 'day')
        .toDate()
    };
  },
  methods: {
    i18n(subkey, ns) {
      return this.$t(`white-label.${ns || 'widgets.orderStatus'}.${subkey}`);
    },
    onDateRangeChanged($event) {
      if (this.selectedDateModel === 5) {
        this.customRangeSelected = true;
      } else {
        this.customRangeSelected = false;
        this.$emit('onFromDateChanged', null);
        this.$emit('onToDateChanged', null);
      }
      this.$emit('onDateRangeChanged', $event);
    },
    onFromDateChanged($event) {
      this.$emit('onFromDateChanged', $event);
    },
    onToDateChanged($event) {
      this.$emit('onToDateChanged', $event);
    },
    applyDateRange() {
      this.$emit('applyDateRange');
    },
    minDate(isFromDate = true) {
      if (isFromDate) {
        return this.getDateValue(-this.maxDateRange);
      } else {
        return this.fromDate ? this.fromDate : this.getDateValue(-this.maxDateRange);
      }
    },
    maxDate(isFromDate = true) {
      if (isFromDate) {
        return this.toDate ? this.toDate : this.getDateValue(-1);
      } else {
        return this.getDateValue(-1);
      }
    },
    getDateValue(days) {
      const now = toTimezoneDate(this.$store.state.applicationSettings.general.settings.timezone);
      return new Date(now.getFullYear(), now.getMonth(), now.getDate() + days);
    }
  },
  computed: {
    id() {
      return `c-historical-orders-date-range-filter-${this._uid}`;
    },
    options() {
      return [
        { value: 0, text: `${this.i18n('dateRangeFilters.yesterday')}` },
        { value: 1, text: `${this.i18n('dateRangeFilters.last3Days')}` },
        { value: 2, text: `${this.i18n('dateRangeFilters.last7Days')}` },
        { value: 3, text: `${this.i18n('dateRangeFilters.last30Days')}` },
        { value: 4, text: `${this.i18n('dateRangeFilters.last60Days')}` },
        { value: 5, text: `${this.i18n('dateRangeFilters.custom')}` }
      ];
    },
    showApplyButton() {
      return this.powerUser && this.selectedDateModel === 5;
    }
  },
  mounted() {
    this.selectedDateModel = this.selectedDateRangeId;
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/components/custom/c-historical-orders-date-range-filter';
</style>
